import { render, staticRenderFns } from "./grouped-question-element.vue?vue&type=template&id=c2482a9e&scoped=true&"
import script from "./grouped-question-element.vue?vue&type=script&lang=js&"
export * from "./grouped-question-element.vue?vue&type=script&lang=js&"
import style0 from "./grouped-question-element.vue?vue&type=style&index=0&id=c2482a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2482a9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VIcon,VSheet,VTooltip})
